import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useSetting } from '../../utilities/sharedHooks/settings';

const TermsCheckbox = ({
  checked,
  disabled,
  onChange,
  contentUrlKey,
  children,
  label,
  trailing,
  showRightToInfo,
  isUSSignup,
}) => {
  const { t: translate } = useTranslation();
  const [termUrl] = useSetting('content_urls', contentUrlKey);
  const [urlSettings] = useSetting('content_urls', [
    'right_to_info_doc',
    'content_url_notice_of_privacy_practices',
    'content_url_account_opening_disclosures',
  ]);

  const {
    right_to_info_doc: rightToInfo,
    content_url_notice_of_privacy_practices: usPrivacyPractices,
    content_url_account_opening_disclosures: usAccountOpeningDisclosures,
  } = urlSettings || {
    right_to_info_doc: '',
    content_url_notice_of_privacy_practices: '',
    content_url_account_opening_disclosures: '',
  };

  if (isUSSignup) {
    return (
      <div className="d-flex flex-row align-items-center form-check">
        <div>
          <input
            disabled={disabled}
            type="checkbox"
            className="form-check-input"
            checked={checked}
            onChange={onChange}
            required
          />
        </div>
        <label
          className="form-check-label letter-spacing-sm"
          style={{
            opacity: disabled ? 0.5 : 1,
            pointerEvents: disabled ? 'none' : 'auto',
            cursor: disabled ? 'not-allowed' : 'auto',
          }}>
          <p className="ps-2 text-f6">
            {translate('terms_checkbox_label')}{' '}
            <a
              target="_blank"
              className="link text-decoration-none"
              href={termUrl || '#'}
              rel="noreferrer">
              {translate('terms_checkbox_link_label')}
            </a>
            {' , '}
            {children}
            <a
              target="_blank"
              className="link text-decoration-none"
              href={usAccountOpeningDisclosures}
              rel="noreferrer">
              {translate('us_account_opening_disclosures')}
            </a>{' '}
            {translate(trailing)}{' '}
            <a
              target="_blank"
              className="link text-decoration-none"
              href={usPrivacyPractices || '#'}
              rel="noreferrer">
              {translate('us_notice_of_privacy_practices')}
            </a>{' '}
            {translate(trailing)}{' '}
            <a
              target="_blank"
              className="link text-decoration-none"
              href="https://www.crossriver.com/legal/privacy-notice"
              rel="noreferrer">
              {translate('us_crb_privacy_practices')}
            </a>
          </p>
        </label>
      </div>
    );
  }

  return (
    <div className="d-flex flex-row align-items-center form-check">
      <div>
        <input
          type="checkbox"
          className="form-check-input"
          checked={checked}
          onChange={onChange}
          required
        />
      </div>
      <label className="form-check-label letter-spacing-sm">
        <p className="ps-2 text-f6">
          {translate(label)}{' '}
          <a
            target="_blank"
            className="link text-decoration-none"
            href={termUrl || '#'}
            download={translate('cryptodraft_terms_title')}
            rel="noreferrer">
            {translate('terms_checkbox_link_label')}
          </a>{' '}
          {children}
          {translate(trailing)}{' '}
          {showRightToInfo && (
            <a
              target="_blank"
              className="link text-decoration-none"
              href={rightToInfo || '#'}
              download={translate('terms_checkbox_link_label_right_to_info')}
              rel="noreferrer">
              {translate('terms_checkbox_link_label_right_to_info')}
            </a>
          )}
        </p>
      </label>
    </div>
  );
};

export default TermsCheckbox;

TermsCheckbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  contentUrlKey: PropTypes.string.isRequired,
  children: PropTypes.node,
  label: PropTypes.string,
  trailing: PropTypes.string,
  showRightToInfo: PropTypes.bool,
  isUSSignup: PropTypes.bool,
  disabled: PropTypes.bool,
};

TermsCheckbox.defaultProps = {
  children: null,
  label: 'terms_checkbox_label',
  trailing: 'terms_checkbox_trailing_label',
  showRightToInfo: true,
  isUSSignup: false,
  disabled: false,
};
